import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const CustomSelect = styled(SelectMui)`
    width: 100%;
    margin: 0 !important;
    height: 2.5rem !important;

    & .MuiFormControl-root {
        width: 100% !important;
        margin: 0 !important;
    }

    & .MuiInputBase-root {
        width: 100% !important;
    }
`

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1.2rem;
    gap: 1.8rem;
    align-items: center;
    width: 100%;
`

export const ContainerButton = styled.div`
    display: flex;
    margin-top: 1rem;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    width: 100%;
`

export const CustomButton = styled(ButtonMui)`
    width: 16rem !important;
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 100% !important;
    height: 2.5rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const CustomTextWrapper = styled.div`
    height: 3rem !important;
    display: flex;
    gap: 1.5rem;
    max-width: 58rem;
    width: 58rem;
`

export const InputRowWrapper = styled.div`
    display: grid;
    grid-template-columns: 24rem 24rem 10rem;
    gap: 1rem;
    max-width: 58rem;
    width: 58rem;
    align-items: center;
    height: 3rem;
`

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    justify-self: start;

    .MuiCheckbox-root {
        padding: 4px;
    }
`

export const CustomContainerTextArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 1.5rem;
    align-items: center;
    justify-content: center;
    max-width: 58rem;
    width: 58rem;
`
